import { RuleDTO } from './rule';

export class RulesDependFieldsDTO {

    protected constructor(attributes?: object) {
        return attributes;
    }

    static create(attributes: any): any {
        let dependFields = attributes ? JSON.parse(attributes) : {};
        // if the source array is blank, return an object and not array
        dependFields = !Array.isArray(dependFields) && typeof dependFields === 'object' ? dependFields : {};
        for (const prop in dependFields) {
            if (Object.prototype.hasOwnProperty.call(dependFields, prop)) {
                dependFields[prop] = RuleDTO.create(dependFields[prop]);
            }
        }
        return new this(dependFields);
    }

}

